module.exports = __webpack_public_path__ + "static/img/KN.e99019b0.svg";